import Vue from 'vue'
import 'modules/product-card/product-card.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default el => new Vue({
  el,
  data () {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        navigation: {
          nextEl: '.bundle-products-list__arrow.next',
          prevEl: '.bundle-products-list__arrow.prev'
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  }
})
